/**
 * 服务号菜单
 */
import React from 'react';
import { Button, Row, Col, Icon, Tooltip } from 'antd';
import PageLayout from '../../ui/PageLayout';
import MenuEdit from './WechatMenuEdit';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import { global_data } from '../../ui/auth'

class MenuIndex extends React.Component {

    columns = [{
        title: '名称',
        dataIndex: 'name',
        width: '20%',
    }, {
        title: '类型',
        dataIndex: 'type',
        width: '10%',
    }, {
        title: '消息内容',
        dataIndex: 'message',
        width: '20%',
    }, {
        title: '链接',
        dataIndex: 'url',
        width: '20%',
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '10%',
        format: {0:'正常',1 :'删除', 2:'停用'}
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("WECHAT_MENU_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("WECHAT_MENU_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("WECHAT_MENU_ENABLE")?
                <Tooltip title="启用">
                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.enable.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("WECHAT_MENU_DISABLE")?
                <Tooltip title="停用">
                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.disable.bind(this, record.id)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        getLoadData: ()=>{return {}}
    };

    add = () => {
        this.setState({ editData: {} });
        this.showModal();
    }

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false });
    };

    //修改
    update = (info, e) => {
        this.setState({ editData: info });
        this.showModal();
    }

    //删除
    delete = (info, e) => {
        messager.confirm("是否删除该菜单？", () => {
            http.post({
                url: '/wx/menu/delete',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("删除成功！");
                }
            });
        });
    }

    //启用
    enable = (info, e) => {
        messager.confirm("是否启用该菜单？", () => {
            http.post({
                url: '/wx/menu/enable',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("启用成功！");
                }
            });
        });
    }

    //停用
    disable = (info, e) => {
        messager.confirm("是否停用该菜单？", () => {
            http.post({
                url: '/wx/menu/disable',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("停用成功！");
                }
            });
        });
    }

    //新菜单应用生效
    effect = (info, e) => {
        messager.confirm("是否应用新菜单到公众号？", () => {
            http.post({
                url: '/wx/menu/createMenu',
                success: (res) => {
                    messager.notify("应用成功！");
                }
            });
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("WECHAT_MENU_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                                {global_data.authCode.includes("WECHAT_MENU_APPLY")?
                                <Button type="primary" onClick={this.effect} style={{marginLeft: "10px"}}>应用新菜单</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    requestType="get"
                    rowKey="id" url="/wx/menu/all"
                    columns={this.columns}
                    treeTable = {true}
                    page ={false}
                    defaultExpandAllRows = {false}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                    getLoadData={(func) => {this.setState({ getLoadData: func }) }}
                />
                <MenuEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    orgTree = {this.state.getLoadData}
                />
            </div>
        )
    }
}

export default MenuIndex;